module.exports = function() {
  return new Worker(__webpack_public_path__ + "ac1cdcb72d4b595f1b9d.worker.js");
};